import ContactForm from './ContactForm';
import CoreLayout from './CoreLayout';
import Header from './Header';
import Slider from './Slider';
import './StyledDropdown';

function init() {
  ContactForm.init();
  Header.init();
  Slider.init();
  
  const selects = document.querySelectorAll('.prolocker-form select');
  selects.forEach(s => window['Plaintext'].StyledDropdown.init(s));
}

window.addEventListener('DOMContentLoaded', init);
CoreLayout.watchDimensions();
